import { render, staticRenderFns } from "./call-notes-widget.vue?vue&type=template&id=d318a8aa&"
import script from "./call-notes-widget.vue?vue&type=script&lang=js&"
export * from "./call-notes-widget.vue?vue&type=script&lang=js&"
import style0 from "./call-notes-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports